<div class="start-trial-modal">
  <!-- Close button at top right -->
  <app-pencil-button
    class="start-trial-modal__close-btn"
    [theme]="PencilButtonThemeEnum.ICON"
    icon="close"
    [iconConfig]="{ type: IconTypes.materialIcon }"
    (clickEvent)="close()"
    data-name="start-trial-confirmation-modal-close"
  ></app-pencil-button>

  <!-- Left Column: Header (Title & Description) -->
  <div class="start-trial-modal__header">
    <h2 class="start-trial-modal__title">
      {{ 'Bring lessons to life' | translate }}
    </h2>
    <p class="start-trial-modal__description">
      {{
        'Start your 14-day trial to unlock video calling, recording, AI tools, and more!'
          | translate
      }}
    </p>
  </div>

  <!-- Left Column: Image -->
  <div class="start-trial-modal__image-container">
    <img
      src="assets/imgs/start-trial-image.png"
      alt="Start Trial"
      class="start-trial-modal__image"
    />
  </div>

  <!-- Right Column: How It Works -->
  <div class="start-trial-modal__timeline">
    <h3 class="start-trial-modal__timeline-title">
      {{ 'How it works' | translate }}
    </h3>

    <div class="start-trial-modal__steps">
      <!-- Step 1: Today -->
      <div class="start-trial-modal__step">
        <div class="start-trial-modal__step-icon start-trial-modal__step-icon--active">
          <app-pencil-icon name="lock-open" [type]="IconTypes.svgIcon"></app-pencil-icon>
        </div>
        <div class="start-trial-modal__step-content">
          <h4 class="start-trial-modal__step-title">
            {{ 'Today' | translate }}
          </h4>
          <ul class="start-trial-modal__step-list">
            <li>{{ 'Add a payment method' | translate }}</li>
            <li>{{ 'Get full access for 14 days' | translate }}</li>
          </ul>
        </div>
      </div>

      <!-- Step 2: In 14 days -->
      <div class="start-trial-modal__step">
        <div class="start-trial-modal__step-icon start-trial-modal__step-icon--upcoming">
          <app-pencil-icon name="check" [type]="IconTypes.matIcon"></app-pencil-icon>
        </div>
        <div class="start-trial-modal__step-content">
          <h4 class="start-trial-modal__step-title">
            {{ 'In 14 days' | translate }}
          </h4>
          <p class="start-trial-modal__step-text">
            {{ 'Your trial ends' | translate }}<br />
            <span class="start-trial-modal__step-subtext">{{
              'You won’t be charged unless you choose a paid plan.' | translate
            }}</span>
          </p>
        </div>
      </div>
    </div>
  </div>

  <!-- Left Column: Actions (Button & Link) -->
  <div class="start-trial-modal__actions">
    <app-pencil-button
      class="start-trial-modal__start-btn"
      [theme]="PencilButtonThemeEnum.PRIMARY"
      [label]="'Start free trial' | translate"
      icon="arrow_circle_up"
      [iconConfig]="{ type: IconTypes.materialIcon }"
      (clickEvent)="startFreeTrial()"
      data-name="start-trial-confirmation-modal-start"
    ></app-pencil-button>

    <app-pencil-button
      class="start-trial-modal__plans-btn"
      [theme]="PencilButtonThemeEnum.TERTIARY_LINK"
      [label]="'View all plans' | translate"
      (clickEvent)="viewAllPlans()"
      data-name="start-trial-confirmation-modal-plans"
    ></app-pencil-button>
  </div>
</div>
